/**
 * Временное отключение услуги «Пополнение».
 * false — вернуть форму и убрать редиректы с вложенных страниц.
 */
export const PAY_ONLINE_24_DISABLED = true;
